var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    color: "#FFF"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "nonzero",
    d: "M2.5 25 0 22.5l10-10-10-10L2.5 0l10 10 10-10L25 2.5l-10 10 10 10-2.5 2.5-10-10z"
  })));
};
export default SvgClose;